import { createContext } from 'react'

const PulsePillContext = createContext(false)

export default PulsePillContext
